module.exports = __webpack_public_path__ + "img/bg.5b13bfc2.png";